import { BaseCard, CircularSpinner } from 'modules/design-system';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { AuthBaseCardFooter } from '../../components/AuthBaseCardFooter/AuthBaseCardFooter';
import { AuthBaseCardHeader } from '../../components/AuthBaseCardHeader/AuthBaseCardHeader';
import { AuthLayout } from '../../components/AuthLayout/AuthLayout';
import { SignInForm } from '../../components/SignInForm/SignInForm';
import { useRouteUserBasedOnAuthenticationStrategy } from './useRouteUserBasedOnAuthenticationStrategy';

export const SignInPage = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation('user', { keyPrefix: 'user.signIn' });

  const r = searchParams.get('r');
  const loginHintParam = searchParams.get('login_hint');

  const routeUserBasedOnAuthenticationStrategy =
    useRouteUserBasedOnAuthenticationStrategy(r);

  const [isLoadingAuthenticationStrategy, setIsLoadingAuthenticationStrategy] =
    useState(!!loginHintParam);

  useEffect(() => {
    if (!loginHintParam) return;
    routeUserBasedOnAuthenticationStrategy(loginHintParam).catch(() => {
      setIsLoadingAuthenticationStrategy(false);
    });
  }, [loginHintParam, routeUserBasedOnAuthenticationStrategy]);

  const handleSubmit = (email: string) =>
    routeUserBasedOnAuthenticationStrategy(email);

  return (
    <AuthLayout>
      <BaseCard>
        <AuthBaseCardHeader title={t('header')} />
        {isLoadingAuthenticationStrategy ? (
          <CircularSpinner />
        ) : (
          <>
            <SignInForm onSubmit={handleSubmit} />
            <AuthBaseCardFooter
              link={{
                to: '/signup',
                label: t('footer.signUp'),
              }}
              navigationLink={{
                to: 'https://www.hiboo.io',
                label: t('footer.whatsHiboo'),
              }}
            />
          </>
        )}
      </BaseCard>
    </AuthLayout>
  );
};
